module.exports = __webpack_public_path__ + "1d9cab416ffb42ecd8bb31bb61739001.svg";